(() => {
  const bind = (root) => {
    if (!root || root._catBound) return;
    root._catBound = true;
    const rows = root.querySelectorAll('.cat-row');
    if (!rows.length) return;

    const update = () => {
      const trigger = window.innerHeight * 0.55;
      rows.forEach((row) => {
        const circle = row.querySelector('.cat-circle');
        if (!circle) return;
        const rect = row.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        if (center <= trigger) {
          circle.classList.add('is-active');
        } else {
          circle.classList.remove('is-active');
        }
      });
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  };

  const init = (scope) => {
    const root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('.cat-rows').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
